"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var React = require("react");
var Image_styles_1 = require("./Image.styles");
var Image = function (_a) {
    var AltText = _a.AltText, ShowImage = _a.ShowImage, OnLoad = _a.OnLoad, Role = _a.Role, Src = _a.Src;
    return (React.createElement(Image_styles_1.Img, { alt: AltText, "aria-hidden": !ShowImage, onLoad: OnLoad, role: Role, src: Src, style: { opacity: ShowImage ? 1 : 0 } }));
};
exports.Image = Image;
